import { isRequired, isUrl } from 'validations/defaultMessages';
import * as Yup from 'yup';

const MaterialSchema = Yup.object().shape({
  type: Yup.string().required(isRequired('type')),
  description: Yup.string().required(isRequired('descrição')),
  link: Yup.string()
    .nullable()
    .when('type', {
      is: 'l',
      then: Yup.string().required(isRequired('link')).url(isUrl('link')),
    }),
  file_id: Yup.string()
    .nullable()
    .when('type', {
      is: 'm',
      then: Yup.string().required(isRequired('file_id')),
    }),
});

export default MaterialSchema;
